export default {
  id: "topSellingSuppliers",
  name: "",
  description: "",
  report: {
    name: "Top Selling Suppliers",
    chartType: "TABLE",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "Supplier",
      dimensions: ["Supplier.name"],
      measures: ["SaleItem.units_sold"],
      sort: {
        direction: "desc",
        by: "SaleItem.units_sold",
      },
      filters: [
        {
          member: "Supplier.name",
          operator: "set",
        },
      ],
      compare: true,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
